import CityPageTemplate from "@/components/site/CityPageTemplate";

export default function FinanzberatungMoers() {
  return (
    <CityPageTemplate
      city="Moers"
      slug="moers"
      intro="Moers am Niederrhein – unabhängige Finanzberatung für eine Region im Wandel."
      description="Unabhängige & digitale Finanzberatung für Moers: Altersvorsorge, ETF, Steueroptimierung und staatliche Förderungen. Kostenlose Erstberatung – 100% digital."
    />
  );
}
